import { PhoneCall } from "@phosphor-icons/react";
import { BUSINESS } from "../data/constants";

export default function CallButton({
  size = "md",
  label,
  testId = "call-now-button",
  className = "",
  block = false,
  variant = "orange",
}) {
  const isOrange = variant === "orange";
  const sizeCls =
    size === "lg"
      ? "px-8 py-5 text-lg md:text-xl"
      : size === "sm"
        ? "px-4 py-2 text-sm"
        : "px-6 py-4 text-base";

  const base = isOrange
    ? "bg-[#FF6B00] text-white hover:bg-[#E66000] shadow-lg shadow-orange-900/10"
    : "bg-white text-[#1B2A4A] border-2 border-white hover:bg-[#1B2A4A] hover:text-white hover:border-[#1B2A4A]";

  return (
    <a
      href={BUSINESS.phoneHref}
      data-testid={testId}
      onClick={() => {
        if (window.gtag) {
          window.gtag("event", "click_to_call", {
            event_category: "engagement",
            event_label: testId,
          });
        }
      }}
      className={`inline-flex items-center justify-center gap-3 rounded-sm font-bold font-display transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 ${sizeCls} ${base} ${block ? "w-full" : ""} ${className}`}
    >
      <PhoneCall weight="fill" size={size === "lg" ? 24 : 20} />
      <span className="phone-number">
        {label || `CALL NOW  ${BUSINESS.phone}`}
      </span>
    </a>
  );
}
